import React, { useState } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { Paragraph } from "components/core/Typography";
import { ClickToCall } from "components/brand/ClickToCall";
import { FacilityPageSection } from "components/facility/FacilityPageSection";
import { StarReviewsCount } from "components/review/StarReviewsCount";
import { getTollfree } from "store/modules/phone";

const LocationSection = ({ address, name, reviews, url }) => {
	const [phone, setPhone] = useState({});
	const dispatch = useDispatch();
	const handleFetchNumber = async (data) => {
		const {
			payload: { result }
		} = await dispatch(getTollfree(data));
		setPhone(result);
		return result;
	};
	return (
		<FacilityPageSection
			title="Location"
			isCollapsable
		>
			<Paragraph
				weight="semiBold"
				className="hide-for-desktop"
				size="small"
			>
				{name}
			</Paragraph>
			<Paragraph size="small">{address}</Paragraph>
			<div className="facility-page-phone-review hide-for-desktop">
				<ClickToCall
					underline
					handleFetchNumber={handleFetchNumber}
					phone={phone}
				/>
				<StarReviewsCount
					number={reviews.number}
					average={reviews.average}
					url={url}
				/>
			</div>
		</FacilityPageSection>
	);
};

LocationSection.propTypes = {
	address: PropTypes.string,
	name: PropTypes.string,
	reviews: PropTypes.object,
	url: PropTypes.string
};

export default LocationSection;
